import React from 'react';
import { connect } from "react-redux";
import { Grid } from "semantic-ui-react";
import Header from "../../common/components/Header";
import KYBTestCacheTable from "./KYBTestCacheTable";
import { InlineLoading } from "../../common/partials/Loading";
import KYBTestcacheSidebarFilters from "./KYBTestCacheSidebarFilters";
import { fetchKYBTestcacheTableData, unmountKYBTestcache } from "../actions/KYBTestCacheActions";
import Breadcrumb from '../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../veritas/breadcrumb/BreadcrumbActions';
import Sidebar from "../../common/components/Sidebar";
import SupportSidebarButtons from "../shared/SupportSidebarButtons";

export class KYBTestCacheListPage extends React.Component {

    componentDidMount() {
        this.props.getKYBTestcacheData();
        document.title = `Support - KYB Testcache`;

        this.props.setBreadCrumb({
            parent: { url: '/support', text: 'Support' },
            list: { url: '/support/kyb-testcache', text: 'KYB Test Cache' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    componentWillUnmount() {
        this.props.unmountKYBTestcache();
    }

    render() {
        return (
            <div className="support">
                <Header />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <SupportSidebarButtons />
                            <div className="divider-background">
                                <hr />
                            </div>
                            <KYBTestcacheSidebarFilters />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.kyb_testcache_filtered_state
                            ? (<KYBTestCacheTable KYBTestcacheData={this.props.filtered_kyb_testcache_records} />)
                            : (<InlineLoading />)}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    kyb_testcache_filtered_state: state.support.kybTestcache.kyb_testcache_filtered_state,
    filtered_kyb_testcache_records: state.support.kybTestcache.filtered_kyb_testcache_records,
});

const mapDispatchToProps = dispatch => ({
    getKYBTestcacheData: () => { dispatch(fetchKYBTestcacheTableData()) },
    unmountKYBTestcache: () => { dispatch(unmountKYBTestcache()) },
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYBTestCacheListPage)
